<script lang="ts">
	/**
	 * No link text color for default state (i.e. to embed in fine print block text).
	 */
	export let passive: boolean = false;
	export let href: string = '';
	export let target: string = '_blank';
	export let className: string = '';

	let classes = `${(passive
		? "underline hover:text-link-hover-text active:text-link-active-text disabled:text-link-disabled-text"
		: "text-link-text hover:text-link-hover-text active:text-link-active-text hover:underline visited:text-link-visited-text disabled:text-link-disabled-text")} ${className}`;
</script>

{#if href !== ''}
	<a
		{...$$restProps}
		{href}
		class={classes}
		{target}
		rel="noreferrer"
	>
		<slot />
	</a>
{:else}
	<button
		on:click|preventDefault
		{...$$restProps}
		class={classes}
	>
		<slot />
	</button>
{/if}
